import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NgClass],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'admin-app';

  public readonly environmentLabel = this.getEnvironmentLabel();

  private getEnvironmentLabel(): string | null {
    if (environment.production) return null;

    const labels: Record<string, string> = {
      development: 'desarrollo',
      dev: 'desarrollo',
      test: 'testing',
    };

    return labels[environment.environmentName] ?? environment.environmentName;
  }
}
